import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

const UNSPLASH_URL = 'https://unsplash.com/?utm_source=gromly&utm_medium=referral';

interface Props {
  name: string | null;
  url: string | null;
  className?: string;
}

/**
 * "Photo: Name / Unsplash", linked both ways. Unsplash's terms require a visible
 * credit wherever one of its photos is shown — a hover tooltip doesn't count.
 * Sits on top of clickable cards, so its clicks never reach the card.
 */
export function PhotoCredit({ name, url, className = '' }: Props) {
  const { t } = useTranslation();
  if (!name) return null;
  const stop = (e: MouseEvent) => e.stopPropagation();
  const link = 'underline-offset-2 hover:underline';

  return (
    <span className={`text-[10px] leading-tight text-white/75 truncate ${className}`}>
      {t('common.photo')}:{' '}
      {url
        ? <a href={url} target="_blank" rel="noopener noreferrer" onClick={stop} className={link}>{name}</a>
        : name}
      {' / '}
      <a href={UNSPLASH_URL} target="_blank" rel="noopener noreferrer" onClick={stop} className={link}>Unsplash</a>
    </span>
  );
}
